module.exports = __webpack_public_path__ + "h5/img/banner_3.f705a85a.jpg";